// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'normalize.css'
import VueI18n from 'vue-i18n'
// import CN from './i18n/cn'
import EN from './i18n/en'
import KR from './i18n/kr'
import ID from './i18n/id'
import VI from './i18n/vi'

import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

Vue.use(vueSwiper)
Vue.use(VueI18n)

Vue.config.productionTip = false

// 获取本地语言
// const supportLanguage = ['en', 'ko', 'zh', 'id', 'vi']
// 暂时去掉中文
const supportLanguage = ['en', 'ko', 'id', 'vi']

const lang = navigator.language || navigator.userLanguage // 常规浏览器语言和IE浏览器;
let DEFAULT_LANG = lang.substr(0, 2)
if (supportLanguage.indexOf(DEFAULT_LANG) <= -1) {
  DEFAULT_LANG = 'en'
}
const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: {
    en: EN,
    ko: KR,
    // 'zh': CN,
    id: ID,
    vi: VI
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js